/*
 * @Description:
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2022-06-09 10:37:24
 * @LastEditors: YGQ
 * @LastEditTime: 2024-02-02 11:25:30
 */

/**
 * @description: 数组去重
 * @param {arr} 要去重的数据源
 * @return:
 */
export function unique (arr) {
  return Array.from(new Set(arr));
}

/**
 * @description: 数组对象去重
 * @param {array} 要去重的数据源
 * @param {filed} 指定去重的字段
 * @return:
 */
export function removalArr (array, filed) {
  const newArr = [];
  const obj = {};
  for (var i = 0; i < array.length; i++) {
    if (!obj[array[i][filed]]) {
      newArr.push(array[i]);
      obj[array[i][filed]] = true;
    }
  }
  return newArr;
}

/**
 * @description: 多条件筛选 模糊查询
 * @param {data} 要筛选的数据源
 * @param {term} 筛选条件
 * @return:
 */
export function multiFilter (data, term) {
  const filterKeys = Object.keys(term)
  return data.filter((item) => {
    return filterKeys.every(key => {
      if (!term[key].length) return true
      return !!~term[key].indexOf(item[key])
        || String(item[key]).toLowerCase().includes(String(term[key]).trim().toLowerCase())
    })
  })
}

/**
 * @description: 根据运行环境判断地址
 * @return {*}
 * @author: YGQ
 */
export function getEnvironment () {
  const domain = window.location.hostname;
  if (domain.includes("pms.geemro.com") || domain.includes("vip.geemro.com"))
    return "release"; // 判断生产环境
  if (domain.includes("trial.geemro.com")) return "trial"; // 判断体验环境
  if (domain.includes("dev.geemro.com") || domain.includes("work.dev"))
    return "develop"; // 判断开发环境
  if (domain.includes("localhost") || domain.includes("192.168"))
    return "local"; // 判断本地环境
  console.error("当前部署环境异常");
  return "mock";
}

/**
 * @description: 从选项中找出值相同的一项并返回
 * @return {*}
 * @author: YGQ
 */
export function findOptionsItem (value, options) {
  if (!value || !options) return { label: '' }
  let item = options.find(i => i.value == value)
  return item || { label: '' }
}

/**
 * @description: 从对象中筛选出指定key的值并返回
 * @return {*}
 * @author: YGQ
 */
const filterObj = (form, row) => {
  let keys = row.map((i) => i.key);
  let newForm = {};
  for (const key in form) {
    if (keys.includes(key)) {
      newForm[key] = form[key];
    }
  }
  return newForm;
};

/**
 * @description: 下划线转驼峰
 * @return {*}
 * @author: YGQ
 */
export function underscoreToCamelCase (str) {
  return str.replace(/_(\w)/g, function (match, p1) {
    return p1.toUpperCase();
  });
}

// 首字母大写
export function firstToUpper (str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1)
}

// 数组转对象格式 [{grade: 10, name: '小米卡'}] => {10: {label: '小米卡', value: 10}}
export function createOptionObj (list, key) {
  const obj = {}
  list.map(item => obj[item[key]] = { label: item.name, value: item[key] })
  return obj
}

/**
 * @description: 防抖函数 将多次执行变为最后一次执行
 * @param {fn，wait} 
 * @return:{rule}
 */
export function debounce (fn, wait) {
  let timer = null;
  return function (...args) {
    let that = this
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(function () {
      fn.apply(that, args)
    }, wait)
  }
}

export default {
  filterObj: filterObj,
};
